// FulfillmentDetailsModal.jsx
import React, { useEffect, useState } from 'react';
import { Modal, List, Typography, Spin } from 'antd';
import OrdersService from '../../../services/orders/service';

const FulfillmentDetailsModal = ({ visible, order, onCancel }) => {
  const [fulfillmentDetails, setFulfillmentDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFulfillmentDetails = async () => {
      setLoading(true);
      try {
        const data = await OrdersService.getFulfillmentDetails(order._id);
        setFulfillmentDetails(data);
      } catch (error) {
        console.error('Failed to fetch fulfillment details:', error);
      } finally {
        setLoading(false);
      }
    };

    if (order) {
      fetchFulfillmentDetails();
    }
  }, [order]);

  return (
    <Modal
      title="Fulfillment Details"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      {loading ? (
        <Spin />
      ) : (
        <div>
          <Typography.Text strong>Product Name:</Typography.Text>
          <Typography.Paragraph>{fulfillmentDetails.productName}</Typography.Paragraph>
          <Typography.Text strong>Fulfillment Notes:</Typography.Text>
          <Typography.Paragraph>{fulfillmentDetails.notes}</Typography.Paragraph>
          {fulfillmentDetails.files && fulfillmentDetails.files.length > 0 && (
            <>
              <Typography.Text strong>Files:</Typography.Text>
              <List
                dataSource={fulfillmentDetails.files}
                renderItem={(file) => (
                  <List.Item>
                    <a href={file.url} target="_blank" rel="noopener noreferrer">
                      {file.name}
                    </a>
                  </List.Item>
                )}
              />
            </>
          )}
        </div>
      )}
    </Modal>
  );
};

export default FulfillmentDetailsModal;
